import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { IToast } from '../../../interfaces/components/IToast';
import { IAiModels } from '../../../interfaces/ai-models/IAiModels';
import { IPaginationPayload } from '../../../interfaces/shared/IPaginationPayload';
import { tryToDeleteAiModel, tryToEditAiModel, tryToFetchAiModels } from '../../../store/brokers/partners/ai-models/aiModelsSlice';
import ManageModelsModal from './modals/ManageModelsModal';
import AiModelsTable from './tables/AiModelsTable';
import Button from '../../../shared/button';
import Toast from '../../../shared/toast';


const AiModels = () => {
    const dispatch = useAppDispatch();
    const [models, setModels] = useState<IAiModels[]>();
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const [showModal, setShowModal] = useState<{ show: boolean, data?: any }>();
    const [showToast, setShowToast] = useState<IToast | null>();
    const paginationData = useAppSelector((state) => state.aiModels?.aiModels?.data?.page);
    const loading = useAppSelector((state) => state.aiModels?.aiModelsAreLoading);
    const state = useAppSelector((state) => state.aiModels);

    useEffect(() => {
        if (state?.aiModels?.data?.elements) {
            setModels(state?.aiModels?.data?.elements)
        }
    }, [state])

    const getModelsData = async () => {
        try {
            const data: any = {
                ...paginationState || {},
            }
            await dispatch(tryToFetchAiModels(data)).unwrap();
        } catch (err) {
            console.error(err, 'error')
        }
    }

    useEffect(() => {
        getModelsData()
    }, [paginationState])

    const onChangeState = async (id: string, enabled: boolean) => {
        try {
            const form = new FormData()
            form.append('enabled', `${!enabled}`)
            await dispatch(tryToEditAiModel({ id: id, data: form }))
        } catch (err) {
            console.error(err)
        }
    }

    const onClickShowModal = (data?: any) => {
        setShowModal({ show: true, data: data })
    }

    const onSaveChanges = (type: string, message: string) => {
        setShowToast({ type: type, message: message })
    }

    const onDeleteItem = async (item: any) => {
        try {
            await dispatch(tryToDeleteAiModel(item?._id || ''))
            setShowToast({ type: 'success', message: 'Successfully deleted' })
        } catch (err) {
            setShowToast({ type: 'error', message: 'Something went wrong!' })
        }
    }

    return (
        <div>
            <p className='text-xl mb-5 font-bold dark:text-primary-dark'>AI Models</p>
            <div className='flex flex-col md:flex-row md:justify-end mb-4'>
                <Button
                    label={'Add New AI Model'}
                    className='btn-primary-rounded-less'
                    onClickButton={onClickShowModal}
                />
            </div>
            <AiModelsTable
                rows={models}
                paginationData={paginationData}
                paginationState={paginationState}
                loading={loading}
                setPaginationState={setPaginationState}
                onChangeStatus={onChangeState}
                onClickModal={onClickShowModal}
                onDeleteItem={onDeleteItem}
            />
            {showModal?.show &&
                <ManageModelsModal
                    openModal={showModal?.show}
                    itemId={showModal?.data?._id}
                    handleCloseModal={() => setShowModal(undefined)}
                    onSaveChanges={onSaveChanges}
                />
            }
            {showToast?.message &&
                <Toast
                    type={showToast?.type}
                    text={showToast?.message}
                    onHandleCloseToast={() => setShowToast(null)}
                />
            }
        </div>
    )
}
export default AiModels;